<tab-header [workPackage]="workPackage" />
<op-tab-prs [workPackage]="workPackage" />
